import React, { Component } from "react";
import { CSkeleton } from "@appcues/component-library";

export const withSkeleton = (WrappedComponent, skeletonProps) => {
  class WITHSKELETON extends Component {
    render() {
      const { draftTheme } = this.props;

      return draftTheme ? (
        <WrappedComponent {...this.props} />
      ) : (
        <CSkeleton {...skeletonProps} />
      );
    }
  }

  return WITHSKELETON;
};
